// extracted by LIB_CSS_EXTRACT_LOADER
import "./input_module.css"
export default {"input":"input-KhGasQ"};